import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const PricingSection = () => {
  return (
    <section
          id='tarifas'
          className='py-5 position-relative'
          style={{ backgroundColor: "#f8faff" }}
        >
          <Container>
            <Row className='justify-content-center mb-5'>
              <Col lg={8} className='text-center'>
                <div className='d-flex justify-content-center align-items-center mb-4'>
                  <img
                    src={mboxitoEEUU}
                    alt='Logo empresa EEUU'
                    className='me-3'
                    style={{ height: "100px", objectFit: "contain" }}
                  />
                  <img
                    src={mboxitoMexico}
                    alt='Logo empresa México'
                    style={{ height: "100px", objectFit: "contain" }}
                  />
                </div>
                <Badge bg='primary' className='mb-3 fw-normal fs-6'>
                  TARIFAS COMPETITIVAS
                </Badge>
                <h2 className='display-5 fw-bold mb-3'>
                  Opciones de envío a{" "}
                  <span className='text-primary'>tu medida</span>
                </h2>
                <p className='lead text-muted'>
                  Elige el servicio que mejor se adapte a tus necesidades y
                  presupuesto
                </p>
              </Col>
            </Row>

            {/* --- ESTADOS UNIDOS --- */}
            <Row className='mb-4'>
              <Col>
                <h3
                  className='fw-bold border-bottom pb-2'
                  style={{ color: "#182848" }}
                >
                  Envíos desde Estados Unidos
                </h3>
              </Col>
            </Row>
            <Row className='g-4 align-items-stretch justify-content-center mb-5'>
              {/* Tarjeta 1 - Miami Estándar */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-lg h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #4b6cb7",
                    transform: "translateY(-5px)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-15px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(-5px)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='position-absolute top-0 start-50 translate-middle mt-n3'>
                      <Badge
                        bg='primary'
                        className='rounded-pill px-3 py-2 fw-normal'
                      >
                        MÁS UTILIZADO
                      </Badge>
                    </div>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaPlane size={28} />
                        </div>
                        <h3 className='mb-2'>Aéreo Estándar</h3>
                        <Badge bg='primary' className='mb-2'>
                          Desde Miami, EEUU
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-primary mb-0'>
                            $4.70
                          </span>
                          <span className='ms-2 text-muted'>/lb</span>
                        </div>
                        <Badge
                          bg='primary'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          8-10 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-primary mt-1 me-2' />
                          <span>Reempaque gratis para tus paquetes</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-primary mt-1 me-2' />
                          <span>Rastreo en tiempo real</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-primary mt-1 me-2' />
                          <span>Peso real garantizado</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-primary mt-1 me-2' />
                          <span>
                            Mínimo <strong>1 libra</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-primary text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold'>
                        Ideal para envíos urgentes
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 2 - Marítimo Miami */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #f5a623",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-warning text-warning rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaShip size={28} />
                        </div>
                        <h3 className='mb-2'>Marítimo</h3>
                        <Badge bg='warning' text='dark' className='mb-2'>
                          Desde Miami, EEUU
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-warning mb-0'>
                            $3.00
                          </span>
                          <span className='ms-2 text-muted'>/lb</span>
                        </div>
                        <Badge
                          bg='warning'
                          text='dark'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          15-20 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-warning mt-1 me-2' />
                          <span>Rastreo incluido</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-warning mt-1 me-2' />
                          <span>Reempaque gratis</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-warning mt-1 me-2' />
                          <span>Peso real</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-warning mt-1 me-2' />
                          <span>
                            Mínimo <strong>20 libras</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-warning text-dark p-3 text-center rounded-bottom'>
                      <span className='fw-bold'>
                        Perfecto para cargas grandes
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 3 - Express Miami */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #dc3545",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-danger text-danger rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaRocket size={28} />
                        </div>
                        <h3 className='mb-2'>Envío Express</h3>
                        <Badge bg='danger' className='mb-2'>
                          Desde Miami, EEUU
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-danger mb-0'>
                            $9.70
                          </span>
                          <span className='ms-2 text-muted'>/lb</span>
                        </div>
                        <Badge
                          bg='danger'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          3-5 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-danger mt-1 me-2' />
                          <span>Rastreo incluido</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-danger mt-1 me-2' />
                          <span>Peso mayor: real o volumétrico</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-danger mt-1 me-2' />
                          <span>
                            Mínimo <strong>1 libra</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-danger text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold'>Para máxima urgencia</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* --- MÉXICO --- */}
            <Row className='mb-4'>
              <Col>
                <h3
                  className='fw-bold border-bottom pb-2'
                  style={{ color: "#2a7f62" }}
                >
                  Envíos desde México
                </h3>
              </Col>
            </Row>
            <Row className='g-4 align-items-stretch justify-content-center mb-5'>
              {/* Tarjeta 4 - México Estándar */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-lg h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #2a7f62",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-success text-success rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaPlaneDeparture size={28} />
                        </div>
                        <h3 className='mb-2'>Aéreo Estándar</h3>
                        <Badge bg='success' className='mb-2'>
                          Desde México
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-success mb-0'>
                            $7.70
                          </span>
                          <span className='ms-2 text-muted'>/lb</span>
                        </div>
                        <Badge
                          bg='success'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          8-10 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>Rastreo incluido</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>Peso mayor: real o volumétrico</span>
                        </li>
                        <li className='py-2 d-flex'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>
                            Mínimo <strong>1 libra</strong>
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-success text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold'>
                        Ideal para envíos desde México
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 5 - México Express (MBOX) */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-lg h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #198754",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-success text-success rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaRocket size={28} />
                        </div>
                        <h3 className='mb-2'>Envio Express México</h3>
                        <Badge bg='success' className='mb-2'>
                          Desde México
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-success mb-0'>
                            $9.70
                          </span>
                          <span className='ms-2 text-muted'>/lb</span>
                        </div>
                        <Badge
                          bg='success'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          1-4 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-3 small'>
                        <li className='py-1 d-flex text-muted'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>
                            Manejo: <strong>$4.70</strong> (cobro único)
                          </span>
                        </li>
                        <li className='py-1 d-flex text-muted'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>
                            Mínimo de envío: <strong>5 libras</strong>
                          </span>
                        </li>
                        <li className='py-1 d-flex text-muted'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>Peso mayor: real o volumétrico</span>
                        </li>
                        <li className='py-1 d-flex text-muted'>
                          <FaCheckCircle className='text-success mt-1 me-2' />
                          <span>
                            Despachos: <strong>Lunes (quincenal)</strong>
                          </span>
                        </li>
                      </ul>
                      <div
                        className='mt-auto p-2 bg-light rounded border mb-3'
                        style={{ fontSize: "0.75rem" }}
                      >
                        <strong>Etiquetado:</strong> Ref: "Servicio Express 2S
                        Honduras". Nombre: <strong>MXS Juan Pérez</strong>.
                      </div>
                    </div>
                    <div className='bg-success text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold'>Corte de carga: Miércoles</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* --- ESPAÑA --- */}
            <Row className='mb-4'>
              <Col>
                <h3
                  className='fw-bold border-bottom pb-2'
                  style={{ color: "#0d6efd" }}
                >
                  Envíos desde España
                </h3>
              </Col>
            </Row>
            <Row className='g-4 align-items-stretch justify-content-center mb-5'>
              {/* Tarjeta 6 - España Aéreo */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #0d6efd",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-primary bg-opacity-10 text-primary rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaPlane size={28} />
                        </div>
                        <h3 className='mb-2'>Aéreo Estándar</h3>
                        <Badge bg='primary' className='mb-2'>
                          Desde España
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-primary mb-0'>
                            $17.70
                          </span>
                          <span className='ms-2 text-muted'>/lb (5+ lbs)</span>
                        </div>
                        <Badge
                          bg='primary'
                          text='light'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          8-15 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-primary mt-1 me-2 flex-shrink-0' />
                          <span>2 salidas mensuales</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-primary mt-1 me-2 flex-shrink-0' />
                          <span>Reempaque gratis</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-primary mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>1 a 4 lbs:</strong> $22.00 /lb
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-primary mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>Manejo y seguro:</strong> $11.00 (fijo)
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-primary text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold' style={{ fontSize: "0.9rem" }}>
                        Consultar productos permitidos
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 7 - España Marítimo */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #0dcaf0",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-info bg-opacity-10 text-info rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaShip size={28} />
                        </div>
                        <h3 className='mb-2'>Marítimo</h3>
                        <Badge bg='info' text='dark' className='mb-2'>
                          Desde España
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-info mb-0'>
                            $7.70
                          </span>
                          <span className='ms-2 text-muted'>/lb (5+ lbs)</span>
                        </div>
                        <Badge
                          bg='info'
                          text='dark'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          35-45 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-info mt-1 me-2 flex-shrink-0' />
                          <span>1 salida mensual</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-info mt-1 me-2 flex-shrink-0' />
                          <span>Reempaque gratis</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-info mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>1 a 4 lbs:</strong> $18.00 /lb
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-info mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>Manejo y seguro:</strong> $11.00 (fijo)
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-info text-dark p-3 text-center rounded-bottom'>
                      <span className='fw-bold' style={{ fontSize: "0.9rem" }}>
                        Consultar productos permitidos
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* --- CHINA --- */}
            <Row className='mb-4'>
              <Col>
                <h3
                  className='fw-bold border-bottom pb-2'
                  style={{ color: "#dc3545" }}
                >
                  Envíos desde China
                </h3>
              </Col>
            </Row>
            <Row className='g-4 align-items-stretch justify-content-center'>
              {/* Tarjeta 8 - China Marítimo Pequeño */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #dc3545",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaBox size={28} />
                        </div>
                        <h3 className='mb-2'>Marítimo Pequeño</h3>
                        <Badge bg='danger' className='mb-2'>
                          Desde China
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-danger mb-0'>
                            $4.70
                          </span>
                          <span className='ms-2 text-muted'>
                            /lb (5-50 lbs)
                          </span>
                        </div>
                        <Badge
                          bg='danger'
                          text='light'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          48-60 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-danger mt-1 me-2 flex-shrink-0' />
                          <span>Max 0.05 CBM / 2 salidas al mes</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-danger mt-1 me-2 flex-shrink-0' />
                          <span>Guía para el proveedor incluida</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-danger mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>1 a 4 lbs:</strong> $18.00 /lb
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-danger mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>Manejo y seguro:</strong> $8.00 (fijo)
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-danger text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold' style={{ fontSize: "0.9rem" }}>
                        Notificar antes de comprar
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 9 - China Paquetería Mínima */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #6f42c1",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div
                          className='bg-secondary bg-opacity-10 text-secondary rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'
                          style={{ color: "#6f42c1" }}
                        >
                          <FaBoxes size={28} style={{ color: "#6f42c1" }} />
                        </div>
                        <h3 className='mb-2'>Paquetería Mínima</h3>
                        <Badge
                          style={{ backgroundColor: "#6f42c1" }}
                          className='mb-2'
                        >
                          Desde China
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span
                            className='h2 fw-bold mb-0'
                            style={{ color: "#6f42c1" }}
                          >
                            $75.00
                          </span>
                          <span className='ms-2 text-muted'>/normal</span>
                        </div>
                        <Badge
                          style={{ backgroundColor: "#6f42c1" }}
                          text='light'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          48-60 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle
                            className='mt-1 me-2 flex-shrink-0'
                            style={{ color: "#6f42c1" }}
                          />
                          <span>
                            <strong>Rango:</strong> 0.01 a 0.083 CBM
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle
                            className='mt-1 me-2 flex-shrink-0'
                            style={{ color: "#6f42c1" }}
                          />
                          <span>
                            <strong>Electrónica:</strong> $87.00
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle
                            className='mt-1 me-2 flex-shrink-0'
                            style={{ color: "#6f42c1" }}
                          />
                          <span>2 salidas al mes + Guía a proveedor</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle
                            className='mt-1 me-2 flex-shrink-0'
                            style={{ color: "#6f42c1" }}
                          />
                          <span>
                            <strong>Manejo y seguro:</strong> $40.00 (fijo*)
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div
                      className='text-white p-3 text-center rounded-bottom'
                      style={{ backgroundColor: "#6f42c1" }}
                    >
                      <span className='fw-bold' style={{ fontSize: "0.9rem" }}>
                        Sujeto a revisión de producto
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Tarjeta 10 - China Carga CBM */}
              <Col lg={4} md={6}>
                <Card
                  className='border-0 shadow-sm h-100 d-flex flex-column'
                  style={{
                    borderRadius: "12px",
                    transition: "transform 0.3s ease",
                    borderTop: "4px solid #198754",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-10px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  <Card.Body className='p-0 d-flex flex-column flex-grow-1'>
                    <div className='p-4 pb-0 flex-grow-1 d-flex flex-column'>
                      <div className='text-center mb-4'>
                        <div className='bg-light-success bg-opacity-10 text-success rounded-circle d-inline-flex align-items-center justify-content-center p-3 mb-3'>
                          <FaPallet size={28} />
                        </div>
                        <h3 className='mb-2'>Carga CBM</h3>
                        <Badge bg='success' className='mb-2'>
                          Desde China
                        </Badge>
                        <div className='d-flex justify-content-center align-items-baseline mb-3'>
                          <span className='h2 fw-bold text-success mb-0'>
                            $820
                          </span>
                          <span className='ms-2 text-muted'>/CBM Normal</span>
                        </div>
                        <Badge
                          bg='success'
                          text='light'
                          className='rounded-pill px-3 py-1 mb-3'
                        >
                          48-60 días hábiles
                        </Badge>
                      </div>
                      <ul className='list-unstyled mb-4'>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-success mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>Rango:</strong> 0.084 a 1 CBM
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-success mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>CBM Electrónico:</strong> $950.00
                          </span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-success mt-1 me-2 flex-shrink-0' />
                          <span>2 salidas al mes + Reempaque gratis</span>
                        </li>
                        <li className='py-2 d-flex align-items-start'>
                          <FaCheckCircle className='text-success mt-1 me-2 flex-shrink-0' />
                          <span>
                            <strong>Seguro:</strong> Sujeto a revisión
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className='bg-success text-white p-3 text-center rounded-bottom'>
                      <span className='fw-bold' style={{ fontSize: "0.9rem" }}>
                        Consultar medidas y productos
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <div
              className='mt-5 p-4 text-white'
              style={{
                background: "#182848",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              <h4 className='fw-bold mb-3' style={{ color: "#F5A623" }}>
                Información Importante
              </h4>

              <ul
                className='mb-0'
                style={{ fontSize: "1.05rem", lineHeight: "1.6" }}
              >
                <li className='mb-2'>
                  Verifica que los datos de la dirección estén bien y que lleven la palabra <strong>(Mbox)</strong>.
                </li>
                <li className='mb-2'>
                  Notificanos antes de comprar en los serviciosde España, México y China <strong>México</strong> o{" "}
                  <strong>Express USA</strong>.
                </li>
                <li className='mb-2'>
                  Las tarifas en Estados Unidos no aplican manejo ni ISV, lo cual son un monto fijo no por áquete
                </li>
                <li>
                  No cobramos extra por tecnología en Usa
                </li>
              </ul>
            </div>

            <style jsx>{`
              .bg-light-primary {
                background-color: rgba(24, 40, 72, 0.1);
              }
              .text-primary {
                color: #182848 !important;
              }
              .bg-primary {
                background-color: #182848 !important;
              }
              .bg-light-success {
                background-color: rgba(42, 127, 98, 0.1);
              }
              .text-success {
                color: #2a7f62 !important;
              }
              .bg-success {
                background-color: #2a7f62 !important;
              }
              .bg-light-warning {
                background-color: rgba(245, 166, 35, 0.1);
              }
              .bg-light-danger {
                background-color: rgba(220, 53, 69, 0.1);
              }
            `}</style>
          </Container>
        </section>
  );
};

export default PricingSection;
